// src/App.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./style.css";

// Toastit
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Home from "./Pages/Home/Home";
import Privacy from "./Pages/Privacy/Privacy";
import NotFound from "./Pages/NotFound/NotFound";

// Components
import Navbar from "./components/Navbar/navbar";
import Footer from "./components/Footer/footer";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import ScrollToHash from "./components/ScrollToHash/ScrollToHash";

function App() {
  return (
    <HelmetProvider>
       <ScrollToHash />
      <div className="App w-full bg-white dark:bg-joyrideNavy z-10">
        <Navbar />

        <div className="container">
          <Routes>
            {/* Ensisijaiset reitit */}
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* Lopuksi wildcard */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>

        {/* Toastien kontaineri, näkyy kaikilla sivuilla */}
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {/* Footer näkyy kaikilla sivuilla */}
        <Footer />

        {/* Evästebanneri */}
        <CookieBanner />
      </div>
    </HelmetProvider>
  );
}

export default App;
